
  document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".mySwiperSlider", {
      loop: true,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      speed: 800,

      breakpoints: {
        0: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 2
        }
      }
    });
  });



  $('.dl_menu_tab .footer-block__heading').click(function() {
  $(this).closest('.dl_menu_tab').toggleClass('active');
});